export const AGGREGATED_COUNT_LABEL_PADDING = 10;
export const AGGREGATED_COUNT_LABEL_FONT_WEIGHT = 300;
export const AGGREGATED_COUNT_LABEL_SIZE = 18;
export const AGGREGATED_COUNT_BADGE_RADIUS =
  (AGGREGATED_COUNT_LABEL_SIZE + AGGREGATED_COUNT_LABEL_PADDING) / 2;
export const MODERNIZED_BLOCK_DIAGRAM_BADGE_HEIGHT = 20;
export const GROUP_HEADER_FONT_HEIGHT = 34;
export const TEXT_PADDING_VERTICAL = 20;
export const MODERNIZED_BLOCK_DIAGRAM_GROUP_HEADER_FONT_HEIGHT = 14;
export const TAB_HEIGHT = GROUP_HEADER_FONT_HEIGHT + TEXT_PADDING_VERTICAL;

export const REFERENCE_PATH_STROKE_WIDTH = 2;
export const SIMPLE_BLOCK_DIAGRAM_COLLAPSE_BUTTON =
  'simple-block-diagram-collapse-button';
